export default "__VITE_ASSET__Dl6JTy_d__"